import { render, staticRenderFns } from "./ImprimirButton.vue?vue&type=template&id=52c33b7e&scoped=true&"
import script from "./ImprimirButton.vue?vue&type=script&lang=ts&"
export * from "./ImprimirButton.vue?vue&type=script&lang=ts&"
import style0 from "./ImprimirButton.vue?vue&type=style&index=0&id=52c33b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c33b7e",
  null
  
)

export default component.exports